export enum TextInputType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
}

export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
}

export enum CheckBoxTheme {
  SQUARE = 'square',
  ROUNDED = 'rounded',
}
